<template>
  <div class="bc-white padding-20 br-4">
    <b class="fs-18">本地化租户</b>
    <el-divider></el-divider>
    <el-empty description="功能开发中"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'LocalTenant', // 本地化租户
  components: {},
  props: {},
  data () {
    return {}
  },
  filters: {},
  computed: {},
  watch: {},
  methods: {},
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>

</style>
